
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: Boolean,
		},
		x: {
			type: Number
		},
		y: {
			type: Number
		},
		groupSelected: {
			type: Boolean
		},
		canAddSubGroup: Boolean
	},
	computed: {
		items():ISelectItem<string>[]{
			let result = [] as ISelectItem<string>[];
			if (this.canAddSubGroup){
				result.push(
					{
						text: this.$ct("new-product-group"),
						value: "new",
						icon: "plus"
					},
				);
			}
			if (this.groupSelected){
				result.push(
					{
						text: this.$ct("rename-product-group"),
						value: "rename",
						icon: "pen"
					},
				);
				result.push(
					{
						text: this.$ct("edit-product-group-properties"),
						value: "edit-properties",
						icon: "cog"
					}
				);
				result.push(
					{
						text: this.$ct("common.delete"),
						value: "delete",
						icon: "trash"
					}
				);
			}
			return result;
		},
		itemEls():Vue[]{
			return this.$refs.items as Vue[];
		}
	},
	methods: {
		onInput(value:boolean){
			console.log("On input", value);
			this.$emit("input", value);
		},
		onClick(value:string){
			this.$emit(value);
		}
	},
	mounted(){
		if (!this.itemEls) return;
		(this.itemEls[0] as any).focus();
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
});
